/**
 * サイト全体共通初期化スクリプト
 *
 * - 各種UIコンポーネントの初期化を一括で実行
 * - ページ全体で必要な共通JSをまとめて管理
 *
 * @example
 *   import { initCommon } from './common/script.js';
 *   initCommon();
 *
 * 注意:
 * - 各モジュールの依存要素やクラス名が変わる場合は要調整
 */
import { HeaderNav, NavCurrentHighlight } from '../modules/header.js';
import { ToTopButton } from '../modules/toTop.js';
import { ScrollAnimator } from '../modules/scrollAnimator.js';
import { FooterYear } from '../modules/footer.js';
import { AnchorScroll, AnchorMenu } from '../modules/anchor.js';
// import { Accordion } from '../modules/accordion.js';
import { VisibilityToggler } from '../modules/visibilityToggler.js';

export const initCommon = () => {
	// JavaScript有効化クラス付与
	document.documentElement.classList.add('enable-javascript');

	// 各UIコンポーネント初期化
	new HeaderNav().init();
	new NavCurrentHighlight().init();
	new ToTopButton().init();
	new ScrollAnimator().init();
	new FooterYear().init();
	// new Accordion('.js-accordion', { onlyOne: true });
	new AnchorScroll('.js-anchor').init();
	new AnchorMenu().init();
	new VisibilityToggler({
		target: document.querySelector('.entry-fixed'),
		trigger: '#recruit-entry',
		mode: 'addClass',
		className: 'is-hidden',
		rootMargin: '0px 0px 10% 0px',
	});
};
